import { FC, HTMLProps } from 'react';

export const EditIcon: FC<HTMLProps<SVGSVGElement>> = (props) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="21"
      viewBox="0 0 20 21"
      fill="none"
      {...props}
    >
      <path
        d="M9.16536 4.74565H4.9987C4.07822 4.74565 3.33203 5.49184 3.33203 6.41232V15.579C3.33203 16.4995 4.07822 17.2457 4.9987 17.2457H14.1654C15.0858 17.2457 15.832 16.4995 15.832 15.579V11.4123M14.6535 3.56713C15.3044 2.91626 16.3597 2.91626 17.0105 3.56713C17.6614 4.21801 17.6614 5.27328 17.0105 5.92416L9.85572 13.079H7.4987L7.4987 10.722L14.6535 3.56713Z"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
